<div
  class="matero-container-wrap"
  [ngClass]="{
    'matero-sidenav-collapsed': options.sidenavCollapsed && options.navPos !== 'top',
    'matero-navbar-side': options.navPos === 'side',
    'matero-navbar-top': options.navPos === 'top',
    'matero-header-above': options.headerPos === 'above',
    'matero-header-fixed': options.headerPos === 'fixed',
    'matero-header-white': options.theme === 'light'
  }"
  [dir]="options.dir"
>
  <!-- Header Above -->
  <app-header
    *ngIf="options.showHeader && options.headerPos === 'above'"
    (toggleSidenav)="sidenav.toggle()"
    [showBranding]="true"
  >
  </app-header>

  <mat-sidenav-container class="matero-container" autosize autoFocus>
    <mat-sidenav
      #sidenav
      class="matero-sidenav"
      [mode]="isOver ? 'over' : 'side'"
      [opened]="options.navPos === 'side' && options.sidenavOpened && !isOver"
      (openedChange)="sidenavOpenedChange($event)"
      (closedStart)="sidenavCloseStart()"
    >
      <app-sidebar> </app-sidebar>
    </mat-sidenav>

    <mat-sidenav-content #content class="matero-content-wrap">
      <app-header
        *ngIf="options.showHeader && options.headerPos !== 'above'"
        [showToggle]="!options.sidenavCollapsed && options.navPos !== 'top'"
        [showBranding]="options.navPos === 'top'"
        (toggleSidenav)="sidenav.toggle()"
      >
      </app-header>

      <div class="matero-content">
        <mtx-loader [loading]="loadingService.isLoading | async">
          <breadcrumb></breadcrumb>
          <router-outlet></router-outlet>
        </mtx-loader>
      </div>
      <app-footer></app-footer>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
